import React from "react";
import cx from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { CurrencyInput } from "@picklebet/ui";
import { AmountPresets } from "@/features/wallet/components/shared/amount-presets/AmountPresets";
import { useWithdrawWizard } from "@/features/wallet/components/withdraw/hooks/useWithdrawWizard";
import * as styles from "./WithdrawAmountInput.module.scss";

const WITHDRAW_INCREMENTS = [10, 25, 50, 100] as const;

type WithdrawAmountInputProps = {
  value: number;
  onChange: (amount: number) => void;
  errorMessage?: string;
};

export const WithdrawAmountInput = ({
  value,
  onChange,
  errorMessage,
}: WithdrawAmountInputProps) => {
  const { currency, withdrawableAmountInCents, submitting } =
    useWithdrawWizard();

  return (
    <>
      <div className={styles.amountContainer}>
        <CurrencyInput
          inputClassName={cx(
            styles.currencyInput,
            value?.toString().length >= 8 && styles.textMd,
          )}
          onChange={(next) => onChange(next)}
          currency={currency}
          canClear={false}
          wrapperClassName={cx(
            styles.currencyInputWrapper,
            submitting && styles.disabled,
          )}
          disableFocusStyling
          noSpacing
          disabled={submitting}
          value={value}
        />
        <AnimatePresence initial={false}>
          {errorMessage && (
            <motion.div
              key={errorMessage}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <span className={styles.errorMessage}>{errorMessage}</span>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AmountPresets
        currency={currency}
        value={value}
        onSelect={onChange}
        increments={WITHDRAW_INCREMENTS}
        maxAmountInCents={withdrawableAmountInCents}
        disabled={submitting}
      />
    </>
  );
};
